<template>
  <a :href="href" target="_blank"
     role='button'
     @click="emitClick"
     :download="description"
     :class="{ 'speech-link': hover, 'disabled': disabled }">
    <div class="row speech-text"
         :class="`speech-text-${type}`">
      <div v-if="src"
           class="col-xs-12 col-sm-6 col-md-3 col-lg-4 text-center speech-img">
        <img :src="require(`@/assets/img/${src}`)"
                             class="img-responsive">
      </div>
      <div class='col-xs-12 speech-texts'
           :class="src == null ? '' : 'col-sm-6 col-md-9 col-lg-8'">
        <h4>
          <span v-for="(t, i) in texts"
                :key="`text-${i}`">
            {{ t }}<br />
          </span>
        </h4>
        <span class="program-subtexts"
              v-for="(st, i) in subtexts"
              :key="`subtext-${i}`">
          <span v-html="st"></span>
          <br />
        </span>
      </div>
      <span class="speech-dl" v-if="hover">
        <span>
          {{hover}}
        </span>
      </span>
    </div>
  </a>
</template>
<script>
import assert from '@/sui/tools/assert'

export default {
  name: 'missionday-speech',
  props: {
    type: {
      type: String,
      required: true
    },

    src: {
      type: String,
      default: null
    },

    texts: {
      type: Array,
      required: true
    },

    subtexts: {
      type: Array,
      required: true
    },

    hover: {
      type: String,
      default: null
    },

    target: {
      type: Object,
      default: null
    },

    disabled: {
      type: Boolean,
      default: false
    },

    description: {
      type: String,
      default: null
    }
  },

  data () {
    return {
    }
  },

  methods: {
    emitClick: function () {
      const target = this.target
      if (target != null || this.disabled) {
        return
      }
      this.$emit('click')
    }
  },

  computed: {
    href: function () {
      const target = this.target
      if (this.disabled || target == null) {
        return null
      }

      const { type, item } = target
      if (item == null) {
        return null
      }

      if (type === 'file') {
        return require(`@/assets/documents/Mission Day/${item}`)
      }

      assert.equals(type, 'link', 'Unknown mission day speech target type')
      return item
    }
  }
}
</script>

<style scoped lang="less">
@import '~variables';

a.disabled {
  cursor: @cursor-disabled;
}

.speech-text {
  position: relative;
  padding: 1rem;
  margin: 2rem 0rem;
  text-align: justify;
  border-radius: 1rem;

  img {
    margin: auto;
    border-radius: 1rem;
  }

  h4 {
    color: black;
  }
  color: @dark-base;
}

.page-section-dark-base {
  .speech-text-std {
    background-color: #ffffff;
  }

  .speech-text-alt {
    background-color: lighten(@base, 40%);
  }
}

.page-section-default {
  .speech-text-std {
    background-color: lighten(@base, 40%);
  }

  .speech-text-alt {
    background-color: #eee;
  }
}

.speech-dl {
  opacity: 0;
  bottom: 10%;
  width: 100%;
  left: 0%;
  position: absolute;
  zOrder: 10;
  background-color: @dark-base;
  color: white;
  transition: .5s ease;
  text-align: center;
  span {
    font-size: 140%;
  }
}

.speech-texts {
  transition: .5s ease;
}

.speech-img {
  transition: .5s ease;
}

.speech-link:hover {
  .speech-texts {
    opacity: 0.2;
  }

  .speech-img {
    opacity: 0.2;
  }

  .speech-dl {
    opacity: 0.8;
  }
}

</style>
